import { useSyncExternalStore } from 'react';

/**
 * «Уведомления о поездке» — the switch on «Настройки», as the mobile rider app has
 * it: on unless the passenger turns it off.
 *
 * On the phone it decides whether the socket is held open while the app is out of
 * sight. Here it decides the two things that reach a passenger who is not looking at
 * the tab: the notifications a tab shows, and whether this browser is subscribed to
 * Web Push (ADR 0027). A browser also has its own permission, which a page can ask
 * for but never take back — so off is this app keeping quiet, and on asks the
 * browser where it has not been asked yet.
 *
 * Kept on this device, as the phone keeps it.
 */
const KEY = 'limuzin.customer.alerts';
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'off';
  } catch {
    return true;
  }
}

let on = read();

export function alertsOn(): boolean {
  return on;
}

export function chooseAlerts(next: boolean): void {
  on = next;
  try {
    if (next) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, 'off');
  } catch {
    // Storage refused: the choice lasts as long as the tab.
  }
  listeners.forEach((heard) => heard());
}

export function onAlertsChanged(heard: () => void): () => void {
  listeners.add(heard);
  return () => listeners.delete(heard);
}

export function useAlerts(): boolean {
  return useSyncExternalStore(onAlertsChanged, alertsOn);
}
